import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';

import "../../../../App.css";


const TableData = () => {

  const [DtDetTable, setDtDetTable, DtDetTableRef]=useStateRef([]);
  let DetTable=[];

  const [DtStDetTable, setDtStDetTable, DtStDetTableRef]=useStateRef([]);
  let StDetTable=[];

 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    sessionStorage.getItem("OrnamentReceipt_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');
   
	
	
   if(sessionStorage.getItem("OrnamentReceipt_Action")=="Add")
   {
	    setSaveButtonText("Save");
      document.getElementById("optGold").checked=true;
      document.getElementById("optSmith").checked=true;
     
    document.getElementById("txtRecNo").value="{Auto}";
    document.getElementById("txtRecDate").value=(new Date()).toISOString().substring(0,10);
   
	//Clear();
   
   }
   else if(sessionStorage.getItem("OrnamentReceipt_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("OrnamentReceipt_EditId"));
   }
   else if(sessionStorage.getItem("OrnamentReceipt_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("OrnamentReceipt_EditId"));
   }
	
   ControlSettings();

   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  getProductList();

  }


  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
   const TMhandleShow1 = () => setTMShow1(true);
    
const [OrderVis,setOrderVis,OrderVisRef]=useStateRef(false);

  const [DtParty, setDtParty]=useState([]);
  const [DtBranch, setDtBranch]=useState([]);
  const [DtOrderNo, setDtOrderNo]=useState([]);
  const [DtProduct, setDtProduct]=useState([]);
  const [DtSubProduct, setDtSubProduct]=useState([]);
  const [ProdName, setProdName,ProdNameRef]=useStateRef([]);
  const [SubProdName, setSubProdName,SubProdNameRef]=useStateRef([]);
  const [DtPurity, setDtPurity]=useState([]);
  const [DtRecMode, setDtRecMode]=useState([]);
  const [isDisabled, setisDisabled]=useState(false);
  const [btndisabled, setDisabled] = useState('disabled');
  
  const [DtStProduct, setDtStProduct]=useState([]);
  const [DtStSubProduct, setDtStSubProduct]=useState([]);
  const [StProdName, setStProdName,StProdNameRef]=useStateRef([]);
  const [StSubProdName, setStSubProdName,StSubProdNameRef]=useStateRef([]);
  const [DtStRecMode, setDtStRecMode]=useState([]);
  const [DetAdd, setDetAdd]=useState(false);
 

  const [AccCode, setAccCode, AccCodeRef] = useStateRef();
  const [OrderNo, setOrderNo, OrderNoRef] = useStateRef();
  const [BranchCode, setBranchCode, BranchCodeRef] = useStateRef();

 
  const [MetalCatRec, setMetalCatRec, MetalCatRecRef] = useStateRef();
 
 async function OpenStoneScreen()
 {
 

  let HeadID=document.getElementById("txtId").value;

  //setDtStDetTable([]);

  //StDetTable=[];

  DetTable=DtDetTable;
       
       var cnt = 0;
       var i=0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {  
            cnt = 0;
        }
let isFound=false;

        for (i = 0; i < cnt; i++)
        {
            if ((DetTable[i].ID == HeadID))
            {
              setDtStDetTable(DetTable[i].StoneDetails);
              StDetTable=DetTable[i].StoneDetails;

              isFound=true;
              break;
            }
        }
        if (isFound==false)
        {
          // setDtStDetTable([]);
          //StDetTable=[];
        }

        setTMShow1(true);
 }

 async function TagPrint()
{


  try
  {
   
    let postData = {
      TagId: document.getElementById("txtRecNo").value
  }

 
  const results = await apiService.postCall("ornamentreceipt/tagprint",postData);


 if (results != "-1") {

 }
}

catch (error) {
  console.log(error);
}
}



  async function CloseStoneScreen()
  {


    let HeadID=document.getElementById("txtId").value;

      StDetTable=DtStDetTable;
       
        var cnt = 0;
        try {
            cnt = StDetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
      let i=0;
      document.getElementById("txtStoneAmt").value="0";
      document.getElementById("txtStonePcs").value="0";
           
        for (i = 0; i < cnt; i++)
        {
           
              document.getElementById("txtStoneAmt").value=val(val( document.getElementById("txtStoneAmt").value)+val(StDetTable[i].StTotalAmt)).toFixed(2);
              document.getElementById("txtStonePcs").value=val(val( document.getElementById("txtStonePcs").value)+val(StDetTable[i].Pcs)).toFixed(2);
            
        }

        Calc();



    setTMShow1(false);
  }


 async function gridAdd () {




      let slno=document.getElementById("txtId").value;
      let ProdName=ProdNameRef.current;
      let SubProdName=SubProdNameRef.current;
      
      let Purity1=document.getElementById("txtPurity1").value;
      let Purity=document.getElementById("txtPurity").value;
      let RecMode=document.getElementById("txtRecMode").value;
      let Pcs=val(document.getElementById("txtPcs").value);
      let PcsRate=val(document.getElementById("txtPcsRate").value);
      let GrossWt=val(document.getElementById("txtGrossWt").value);
      let LessWt=val(document.getElementById("txtLessWt").value);
     
      
      let NetWt=val(document.getElementById("txtNetWt").value);
      let TotalWt=val(document.getElementById("txtTotalWt").value);
      let WasteP=val(document.getElementById("txtWasteP").value);
      let WastePgrm=val(document.getElementById("txtWastePgrm").value);
      let MCPgrm=val(document.getElementById("txtMCPgrm").value);
      let Wasteage=val(document.getElementById("txtWasteage").value);
      let MCPPcs=val(document.getElementById("txtMCPPcs").value);
      let MCValue=val(document.getElementById("txtMCValue").value);
      let Touch=val(document.getElementById("txtTouch").value);
      let StoneAmt=val(document.getElementById("txtStoneAmt").value);
      let StonePcs=val(document.getElementById("txtStonePcs").value);
      let OtherCharges=val(document.getElementById("txtOtherCharges").value);
      let HallMark=val(document.getElementById("txtHallMark").value);
      let PureWt=val(document.getElementById("txtPureWt").value);
      let TotalAmt=val(document.getElementById("txtTotalAmt").value);
      let PcsAmount=val(document.getElementById("txtPcsAmt").value);
      let OrderNo1=(document.getElementById("txtOrderNo1").value);
   

      


if ((ProdName.length>0)&&(SubProdName.length>0)&&(Pcs>0))

{
        DetTable=DtDetTable;


        var cnt = 0;
        try
        {
            cnt = DetTable.length;
           
        }
        catch(err)
        {
            cnt=0;
        }
    
  
      
        var found = false;
        var i=0;

        for (i = 0; i < cnt; i++) {



            if (DetTable[i].ID == slno) {


              DetTable[i].ProdName=ProdName;
              DetTable[i].SubProdName=SubProdName;
              DetTable[i].Purity1=Purity1;
              DetTable[i].Purity=Purity;
              DetTable[i].RecMode=RecMode;
              DetTable[i].Pcs=Pcs;
              DetTable[i].PcsRate=PcsRate;
              DetTable[i].GrossWt=GrossWt;
              DetTable[i].LessWt=LessWt;
              DetTable[i].NetWt=NetWt;
              DetTable[i].TotalWt=TotalWt;
              DetTable[i].WasteP=WasteP;
              DetTable[i].WastePgrm=WastePgrm;
              DetTable[i].MCPgrm=MCPgrm;
              DetTable[i].Wasteage=Wasteage;
              DetTable[i].MCPPcs=MCPPcs;
              DetTable[i].MCValue=MCValue;
              DetTable[i].Touch=Touch;
              DetTable[i].StoneAmt=StoneAmt;
              DetTable[i].StonePcs=StonePcs;
              DetTable[i].OtherCharges=OtherCharges;
              DetTable[i].HallMark=HallMark;
              DetTable[i].PureWt=PureWt;
              DetTable[i].TotalAmt=TotalAmt;
              DetTable[i].PcsAmount=PcsAmount;
              DetTable[i].OrderNo1=OrderNo1;
              DetTable[i].StoneDetails=DtStDetTable;
             
               
              setDtStDetTable([]);
              StDetTable=[];
                //det text box clear

              Clear();

                found = true;
                break;
            }
            else {


                if ((DetTable[i].ProdName == ProdName) && (DetTable[i].SubProdName == SubProdName) && (parseFloat(DetTable[i].Pcs).toFixed(3) == parseFloat(Pcs).toFixed(3))) {
                    swal({
					  title: "",
					  text: "Already Found",
					  icon: "info",
					  button: "Ok"

						});
	
                    found = true;
                    break;

                }
            }
        }


        if (found == false) {

            var row = {
                "ID": parseInt(cnt) + 1
                , "ProdName":ProdName
                , "SubProdName":SubProdName
                , "Purity1":Purity1
                , "Purity":Purity
                , "RecMode":RecMode
                , "Pcs":Pcs
                , "PcsRate":PcsRate
                , "GrossWt":GrossWt
                , "LessWt":LessWt
                , "NetWt":NetWt
                , "TotalWt":TotalWt
                , "WasteP":WasteP
                , "WastePgrm":WastePgrm
                , "Wasteage":Wasteage
                , "MCPgrm":MCPgrm
                , "MCPPcs":MCPPcs
                , "MCValue":MCValue
                , "Touch":Touch
                , "StoneAmt":StoneAmt
                , "StonePcs":StonePcs
                , "OtherCharges":OtherCharges
                , "HallMark":HallMark
                , "PureWt":PureWt
                , "TotalAmt":TotalAmt
                , "PcsAmount":PcsAmount
                , "OrderNo1":OrderNo1
                , "StoneDetails":DtStDetTable
               
            };
            setDtStDetTable([]);
            StDetTable=[];
            
                DetTable[cnt] = row;

             Clear();
            

             //Calc();

               

        }
      
      await setDtDetTable(DetTable);


 


      //alert(JSON.stringify(DtDetTable));

     Calc();
	 
	
}
else
{
	
	swal({
      title: "",
      text: "Fill All Data",
      icon: "info",
      button: "Ok"

    });
	
	
  //alert("Fill All Data");
}

    }

    
async function StgridAdd () {


      let id=document.getElementById("txtId").value;
      let slno=document.getElementById("txtStId").value;
      let ProdName=StProdNameRef.current;
      let SubProdName=StSubProdNameRef.current;
      let RecMode=document.getElementById("txtStRecMode").value;
      let Pcs=val(document.getElementById("txtStPcs").value);
      let PcsRate=val(document.getElementById("txtStPcsRate").value);
      let StWt=val(document.getElementById("txtStWt").value);
      let StAmount=val(document.getElementById("txtStAmount").value);
      let StHnd=val(document.getElementById("txtStHnd").value);
      let StTax=val(document.getElementById("txtStTax").value);
      let StTotalAmt=val(document.getElementById("txtStTotalAmt").value);
      let StShape=(document.getElementById("txtStShape").value);
    

      


if ((ProdName.length>0)&&(SubProdName.length>0)&&(Pcs>0)&&(RecMode.length>0))

{
        StDetTable=DtStDetTable;


        var cnt = 0;
        try
        {
            cnt = StDetTable.length;
           
        }
        catch(err)
        {
            cnt=0;
        }
    
  

        var found = false;
        var i=0;

        for (i = 0; i < cnt; i++) {



            if ((StDetTable[i].ID == slno)) {


              StDetTable[i].ProdName=ProdName;
              StDetTable[i].SubProdName=SubProdName;
              StDetTable[i].RecMode=RecMode;
              StDetTable[i].Pcs=Pcs;
              StDetTable[i].PcsRate=PcsRate;
              StDetTable[i].StWt=StWt;
              StDetTable[i].StAmount=StAmount;
              StDetTable[i].StHnd=StHnd;
              StDetTable[i].StTax=StTax;
              StDetTable[i].StTotalAmt=StTotalAmt;
              StDetTable[i].StShape=StShape;
               
               
                //det text box clear

              StClear();


                found = true;
                break;
            }
            else {


                if ((StDetTable[i].ProdName == ProdName) && (StDetTable[i].SubProdName == SubProdName) && (StDetTable[i].HeadID == id) && (parseFloat(StDetTable[i].Pcs).toFixed(3) == parseFloat(Pcs).toFixed(3))) {
                    swal({
					  title: "",
					  text: "Already Found",
					  icon: "info",
					  button: "Ok"

						});
	
                    found = true;
                    break;

                }
            }
        }


        if (found == false) {

            var row = {
                "ID": parseInt(cnt) + 1
                ,"HeadID": id
                , "ProdName":ProdName
                , "SubProdName":SubProdName
                , "RecMode":RecMode
                , "Pcs":Pcs
                , "PcsRate":PcsRate
                , "StWt":StWt
                , "StAmount":StAmount
                , "StHnd":StHnd
                , "StTax":StTax
                , "StTotalAmt":StTotalAmt
                , "StShape":StShape
            };

                StDetTable[cnt] = row;

             StClear();
            

             //Calc();

               

        }
      
      await setDtStDetTable(StDetTable);


 


      //alert(JSON.stringify(DtDetTable));

     StCalc();
	 
	
}
else
{
	
	swal({
      title: "",
      text: "Fill All Data",
      icon: "info",
      button: "Ok"

    });
	
	
  //alert("Fill All Data");
}

    }


    async function GetTouchDetail()
    {
      

      let ProdName=ProdNameRef.current;
      let SubProdName=SubProdNameRef.current;
      let AccCode=AccCodeRef.current;

        
    let postData = {
      ProdName:ProdName,
      SubProdName:SubProdName,
      AccCode: AccCode
    }

    const results = await apiService.postCall("ornamentreceipt/getTouchDetail",postData);

   if (results != "-1") {

   if(results.data!="")
{   document.getElementById("txtMCPgrm").value=results.data[0][0].McGram;
    document.getElementById("txtWasteP").value=results.data[0][0].Waste;
    document.getElementById("txtWastePgrm").value=results.data[0][0].WasteGram;
    document.getElementById("txtTouch").value=results.data[0][0].Touch;
    document.getElementById("txtMCPPcs").value=results.data[0][0].MCPcs;
  }
 else
 {
    document.getElementById("txtMCPgrm").value="0";
    document.getElementById("txtWasteP").value="0";
    document.getElementById("txtWastePgrm").value="0";
    document.getElementById("txtTouch").value="0";
    document.getElementById("txtMCPPcs").value="0";
 }
    //alert(JSON.stringify(results.data[0][0]));

      }
    
    

    }
    
  async function Clear()
   {

    document.getElementById("txtId").value="0";
      setProdName("");
      setSubProdName("");

      document.getElementById("txtPurity1").value="";
      document.getElementById("txtPurity").value="";
      document.getElementById("txtRecMode").value="";
      document.getElementById("txtPcs").value="";
      document.getElementById("txtPcsRate").value="";
      document.getElementById("txtGrossWt").value="";
      document.getElementById("txtLessWt").value="";
      document.getElementById("txtNetWt").value="";
      document.getElementById("txtTotalWt").value="";
      document.getElementById("txtWasteP").value="";
      document.getElementById("txtWastePgrm").value="";
      document.getElementById("txtMCPgrm").value="";
      document.getElementById("txtMCPPcs").value="";
      document.getElementById("txtMCValue").value="";
      document.getElementById("txtTouch").value="";
      document.getElementById("txtStoneAmt").value="";
      document.getElementById("txtStonePcs").value="";
      document.getElementById("txtOtherCharges").value="";
      document.getElementById("txtHallMark").value="";
      document.getElementById("txtPureWt").value="";
      document.getElementById("txtTotalAmt").value="";
      document.getElementById("txtPcsAmt").value="";
      document.getElementById("txtOrderNo1").value="";
   
      await getSubProduct();


      StDetTable=DtStDetTable;


      var cnt = 0;
      try
      {
          cnt = StDetTable.length;
         
      }
      catch(err)
      {
          cnt=0;
      }
  



      if(cnt>0)
      setDetAdd(true);


		handleClose1();
		
   }


   async function StClear()
   {

      document.getElementById("txtStId").value="0";
      setStProdName("");
      setStSubProdName("");
      document.getElementById("txtStRecMode").value="";
      document.getElementById("txtStPcs").value="";
      document.getElementById("txtStPcsRate").value="";
      document.getElementById("txtStWt").value="";
      document.getElementById("txtStAmount").value="";
      document.getElementById("txtStHnd").value="";
      document.getElementById("txtStTax").value="";
      document.getElementById("txtStTotalAmt").value="";
      document.getElementById("txtStShape").value="";
    
      await getStSubProduct();

        

		
		
   }

 function gridRemove (id) {

  
      
      DetTable=DtDetTable;
       
        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
      let i=0;

        for (i = 0; i < cnt; i++)
        {
            if (DetTable[i].ID == id)
            {
                DetTable.splice(i, 1);
                break;
            }
        }

			setDtDetTable(DetTable);
      
			setSubProdName("");
			
			
			
      //Clear();

    }

function StgridRemove (id) {


      let HeadID=document.getElementById("txtId").value;

      StDetTable=DtStDetTable;
       
        var cnt = 0;
        try {
            cnt = StDetTable.length;
        }
        catch (err) {
            cnt = 0;
        }
     
      let i=0;

        for (i = 0; i < cnt; i++)
        {
            if ((StDetTable[i].ID == id))
            {
                StDetTable.splice(i, 1);
                break;
            }
        }

        setDtStDetTable(StDetTable);
      
			setStSubProdName("");
			
			
			
      //Clear();

    }


function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}

 async function gridEdit (id) {

        await handleShow1();

        DetTable=DtDetTable;

        var cnt = 0;
        try {
            cnt = DetTable.length;
        }
        catch (err) {
            cnt = 0;
        }

    
    
	
	 
        let i=0;

        for (i = 0; i < cnt; i++) {
            if (DetTable[i].ID == id) {

                document.getElementById("txtId").value = id;

             

                setProdName(DetTable[i].ProdName);
                setSubProdName(DetTable[i].SubProdName);
                document.getElementById("txtPurity1").value= DetTable[i].Purity1;
                document.getElementById("txtPurity").value= DetTable[i].Purity;
                document.getElementById("txtRecMode").value= DetTable[i].RecMode;
                document.getElementById("txtPcs").value= DetTable[i].Pcs;
                document.getElementById("txtPcsRate").value= DetTable[i].PcsRate;
                document.getElementById("txtGrossWt").value= DetTable[i].GrossWt;
                document.getElementById("txtLessWt").value= DetTable[i].LessWt;
                document.getElementById("txtNetWt").value= DetTable[i].NetWt;
                document.getElementById("txtTotalWt").value= DetTable[i].TotalWt;
                document.getElementById("txtWasteP").value= DetTable[i].WasteP;
                document.getElementById("txtWastePgrm").value= DetTable[i].WastePgrm;
                document.getElementById("txtWasteage").value= DetTable[i].Wasteage;
                document.getElementById("txtMCPgrm").value= DetTable[i].MCPgrm;
                document.getElementById("txtMCPPcs").value= DetTable[i].MCPPcs;
                document.getElementById("txtMCValue").value= DetTable[i].MCValue;
                document.getElementById("txtTouch").value= DetTable[i].Touch;
                document.getElementById("txtStoneAmt").value= DetTable[i].StoneAmt;
                document.getElementById("txtStonePcs").value= DetTable[i].StonePcs;
                document.getElementById("txtOtherCharges").value= DetTable[i].OtherCharges;
                document.getElementById("txtHallMark").value= DetTable[i].HallMark;
                document.getElementById("txtPureWt").value= DetTable[i].PureWt;
                document.getElementById("txtTotalAmt").value= DetTable[i].TotalAmt;;
                document.getElementById("txtPcsAmt").value= DetTable[i].PcsAmount;
                document.getElementById("txtOrderNo1").value= DetTable[i].OrderNo1;

      await getSubProduct();
      setSubProdName(DetTable[i].SubProdName);

			          break;

            }

          
            
        }



  setDtDetTable(DetTable);
      
	

    }

    async function StgridEdit (id) {

     

      StDetTable=DtStDetTable;

      var cnt = 0;
      try {
          cnt = StDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }

  
  

 
      let i=0;

      for (i = 0; i < cnt; i++) {
          if (StDetTable[i].ID == id) {

              document.getElementById("txtStId").value = id;
              setStProdName(StDetTable[i].ProdName);
              setStSubProdName(StDetTable[i].SubProdName);
              document.getElementById("txtStRecMode").value= StDetTable[i].RecMode;
              document.getElementById("txtStPcs").value= StDetTable[i].Pcs;
              document.getElementById("txtStPcsRate").value= StDetTable[i].PcsRate;
              document.getElementById("txtStWt").value= StDetTable[i].StWt;
              document.getElementById("txtStAmount").value= StDetTable[i].StAmount;
              document.getElementById("txtStHnd").value= StDetTable[i].StHnd;
              document.getElementById("txtStTax").value= StDetTable[i].StTax;
              document.getElementById("txtStTotalAmt").value= StDetTable[i].StTotalAmt;
              document.getElementById("txtStShape").value= StDetTable[i].StShape;
              

    await getStSubProduct();
    setStSubProdName(StDetTable[i].SubProdName);

              break;

          }          
      }

      setDtStDetTable(StDetTable);
    


  }


function StCalc()
    {
  let Pcs=val(document.getElementById("txtStPcs").value);
  let PcsRate=val(document.getElementById("txtStPcsRate").value);
  let StWt=val(document.getElementById("txtStWt").value);
  let StHnd=val(document.getElementById("txtStHnd").value);
  let StTax=val(document.getElementById("txtStTax").value);
  let StRecMode=(document.getElementById("txtStRecMode").value);

  let StoneAmount=0;
  if(StRecMode=="P")
      StoneAmount=val(val(Pcs)*val(PcsRate)).toFixed(2);
  else if(StRecMode=="W") 
      StoneAmount=val(val(PcsRate)*val(StWt)).toFixed(2);
  else if(StRecMode=="C") 
      StoneAmount=val(val(PcsRate)*val(StWt)).toFixed(2);
   
  
  let TotalStAmount=0;
  TotalStAmount=(val(StoneAmount)+val(StHnd)+val(StTax)).toFixed(2);

  document.getElementById("txtStAmount").value=StoneAmount;
  document.getElementById("txtStTotalAmt").value=TotalStAmount;



    }

function Calc()
{
 
  
  let Pcs=val(document.getElementById("txtPcs").value);
  let PcsRate=val(document.getElementById("txtPcsRate").value);
  let GrossWt=val(document.getElementById("txtGrossWt").value);
  let LessWt=val(document.getElementById("txtLessWt").value);
  let WasteP=val(document.getElementById("txtWasteP").value);
  let WastePgrm=val(document.getElementById("txtWastePgrm").value);
  let MCPgrm=val(document.getElementById("txtMCPgrm").value);
  let MCPPcs=val(document.getElementById("txtMCPPcs").value);
  let Touch=val(document.getElementById("txtTouch").value);
  let StoneAmt=val(document.getElementById("txtStoneAmt").value);
  let OtherCharges=val(document.getElementById("txtOtherCharges").value);
  let HallMark=val(document.getElementById("txtHallMark").value);
  let RecMode=(document.getElementById("txtRecMode").value);
  let Wasteage=(document.getElementById("txtWasteage").value);


  let NetWt=val(GrossWt)-val(LessWt);

  if(val(WasteP)>0)
  Wasteage=val(NetWt*WasteP/100).toFixed(2);
  
  if(val(WastePgrm)>0)
  Wasteage=val(val(Wasteage)+(NetWt*WastePgrm)).toFixed(2);
  
  
  let TotalWt=val(NetWt);
  let PureWt=((val(NetWt)+val(Wasteage))*val(Touch)/100).toFixed(2);
  let McValue=val(NetWt * MCPgrm).toFixed(2);

  McValue=val(val(McValue)+(Pcs * MCPPcs)).toFixed(2);

  let TotalAmt=val(OtherCharges)+val(StoneAmt)+val(HallMark)+val(McValue);

  let PcsAmount=0;

  if(RecMode=="PCS RATE")
    {
    PcsAmount=(Pcs*PcsRate).toFixed(2);
    PcsAmount=(val(PcsAmount)+val(TotalAmt)).toFixed(2);
    }
  else if (RecMode=="WEIGHT RATE")
    {
    PcsAmount=(NetWt*PcsRate).toFixed(2);
    PcsAmount=(val(PcsAmount)+val(TotalAmt)).toFixed(2);
  }
  else
    PcsAmount=0;

    document.getElementById("txtPcsAmt").value=PcsAmount;
    document.getElementById("txtTotalAmt").value=TotalAmt;
    document.getElementById("txtNetWt").value=NetWt;
    document.getElementById("txtPureWt").value=PureWt;
    document.getElementById("txtTotalWt").value=TotalWt;
    document.getElementById("txtWasteage").value=Wasteage;
    document.getElementById("txtMCValue").value=McValue;
    

}


async function ControlSettings()
{

  document.getElementById("txtRecNo").disabled ='true';
  document.getElementById("txtRecDate").disabled ='true';
  
  if((sessionStorage.getItem("OrnamentReceipt_Action")=="Edit") || (sessionStorage.getItem("OrnamentReceipt_Action")=="Delete"))
   {
  

    document.getElementById("optSmith").disabled ='true';
    document.getElementById("optDealer").disabled ='true';
    
    document.getElementById("optGold").disabled ='true';
    document.getElementById("optSilver").disabled ='true';
    
    setisDisabled(true);
    

   }

 



}

async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }


  

    const results = await apiService.postCall("ornamentreceipt/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let DetailData=results.data.Detail;
   let StoneDetail=results.data.StoneDetail;
   let dtorderno=results.data.dtOrderNo;

 setOrderVis(true);
  
  if(HeadData[0][0].OrderType=="SMITH")
  {
    document.getElementById("optSmith").checked=true;
  }
  else if(HeadData[0][0].OrderType=="DEALER")
  {
    document.getElementById("optDealer").checked=true;
  }
  


  if(HeadData[0][0].MetalType=="GOLD")
  {
    document.getElementById("optGold").checked=true;
  }
  else if(HeadData[0][0].MetalType=="SILVER")
  {
    document.getElementById("optSilver").checked=true;
  }
  

  await getLookup();
  

  setDtOrderNo(dtorderno);

   document.getElementById("txtRecNo").value =HeadData[0][0].GrnNo;
   document.getElementById("txtRecDate").value=HeadData[0][0].GrnDate.substring(0,10);
   setAccCode(HeadData[0][0].AccCode);
   setOrderNo(HeadData[0][0].CusOrderNo);
   setBranchCode(HeadData[0][0].BranchCode);
   document.getElementById("txtRemarks").value=HeadData[0][0].Remarks;

   await getProductList();

   setProdName("");

   DetTable=DetailData[0];

  
   var cnt = 0;
   try {
       cnt = DetTable.length;
   }
   catch (err) {
       cnt = 0;
   }

   
   var cnt1 = 0;
   try {
       cnt1 = StoneDetail[0].length;
   }
   catch (err) {
       cnt1 = 0;
   }
  

 let i=0;


   for (i = 0; i < cnt; i++)
   {
      let j=0;

      let xStoneDet=[];

      var rowcnt=0;

    
     
      for(j=0;j<cnt1;j++)
      {

      
       
        if(DetTable[i].ID==StoneDetail[0][j].HeadID)
        {

          var row=StoneDetail[0][j];

          xStoneDet[rowcnt] = row;
          rowcnt=rowcnt+1;
        }
      }

      

      DetTable[i].StoneDetails=xStoneDet;


   }
   

   var cnt = 0;
   try
   {
       cnt = DetTable.length;
      
   }
   catch(err)
   {
       cnt=0;
   }



   
   if(cnt>0)
   setDetAdd(true);

   await setDtDetTable(DetTable);


   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
if (DtDetTable.length==0)
{
	swal({

      title: "",
      text: "Please Enter Details",
      icon: "info",
      button: "Ok"

    });
	
	return;
}	
			
			
			
		const optary = document.getElementsByName("group_partytype");
		 let optpartytype="";
		 let i;
		 
		 for(i=0;i<optary.length;i++)
		 {
			 if(optary[i].checked==true)
			 {
				  optpartytype=optary[i].value;
			 }
		 }
		 
		 
	const optary1 = document.getElementsByName("group_metaltype");
     let optmetaltype="";
    
     for(i=0;i<optary1.length;i++)
     {
       if(optary1[i].checked==true)
       {
          optmetaltype=optary1[i].value;
       }
     }
		 
		let postData = {
			"Action" : sessionStorage.getItem("OrnamentReceipt_Action"),
			"EditId" : sessionStorage.getItem("OrnamentReceipt_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate":sessionStorage.getItem("FinMinDate").substring(0,10),
			"FinMaxDate":sessionStorage.getItem("FinMaxDate").substring(0,10),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"RecDate": document.getElementById("txtRecDate").value,
			"AccCode": AccCodeRef.current,
			"PartyType": optpartytype,
			"MetalType": optmetaltype,
			"OrderNo": OrderNoRef.current,
			"Branch": BranchCodeRef.current,
			"Remarks": document.getElementById("txtRemarks").value,
			"DetTable1": DtDetTable
     
		}

    

   const results = await apiService.postCall("ornamentreceipt/Save",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("OrnamentReceipt_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("OrnamentReceipt_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("OrnamentReceipt_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
    BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }




  async function getProductList(){
    try
    {

    const AccCode1 = AccCodeRef.current;
    
  
     
    let postData = {
      AccCode: AccCode1
    }

    
DetTable=[];

await setDtDetTable(DetTable);
    

    const results = await apiService.postCall("ornamentreceipt/getProductList",postData);

   if (results != "-1") {

   
      setDtProduct(results.data[0][0]);
      setDtOrderNo(results.data[1][0]);
      
      }
    }
    catch (error) {
      console.log(error);
    }

  }

   async function getSubProduct(){
    try
    {

   
     let ProdName1=ProdNameRef.current;
     const AccCode1 = AccCodeRef.current;

    
     
      setSubProdName("");

  
     let postData = {
      ProdName: ProdName1,
      AccCode:AccCode1
    }
     
    const results = await apiService.postCall("ornamentreceipt/getSubProduct",postData);

   if (results != "-1") {
      setDtSubProduct(results.data[0]);
      
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  async function getStSubProduct(){
    try
    {

   
     let ProdName=StProdNameRef.current;
    
     
     setStSubProdName("");
      
  
     let postData = {
      ProdName: ProdName
    }
     
    const results = await apiService.postCall("ornamentreceipt/getStSubProduct",postData);

   if (results != "-1") {
      setDtStSubProduct(results.data[0]);
      
      }
    }
    catch (error) {
      console.log(error);
    }

  }


  async function getLookup(){
	 try {
		
    let postData=[];


    const results = await apiService.postCall("ornamentreceipt/Lookup",postData);

	 if (results != "-1") {

    

			setDtParty(results.data[0][0]);
      setDtBranch(results.data[1][0]);
      setDtStProduct(results.data[2][0]);

      let Purity=[
        {"Purity":"91.6"},
		    {"Purity":"ORDINARY"}
      ]

      setDtPurity(Purity);
    
      let RecMode=[
        {"RecMode":"WEIGHT"},
		    {"RecMode":"WEIGHT RATE"},
        {"RecMode":"PCS RATE"}
      ]

      setDtRecMode(RecMode);
    
      let StRecMode=[
        {"RecMode":"P"},
		    {"RecMode":"W"},
        {"RecMode":"C"}
      ]
      setDtStRecMode(StRecMode);
    

      }



    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/smith/ornamentreceipt/list');
  };

  return (
    <>
    <input type="Hidden" id="txtId" />
    <input type="Hidden" id="txtStId" />

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Ornament Receipt Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input id="optGold" value="GOLD"  name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>GOLD</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="SILVER" id="optSilver" name="group_metaltype" type="radio" className='me-2' />
                          <Form.Check.Label>SILVER</Form.Check.Label>
                        </div>
                        
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Rec No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtRecNo" placeholder="" />
                          </div>
						  
						  
						  <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtRecDate" placeholder="" />
                          </div>
						  
						  
                          <div className='col-md-12'>
                            <Form.Label>Party Name</Form.Label>
                             <Select className="" id="txtPartyName" 
                             options={DtParty}
                             isDisabled={isDisabled}
                             value={DtParty.filter(function(option) {
                              return option.value === AccCode;
                            })}
                            onChange=
                            {
                              (e) => {

                                 setAccCode(e.value);
                                 getProductList();
                              }
                              }
                             disabled={false}>
              								
							               </Select>
                          </div>

                          <div className='col-md-12'>
                            <Form.Label>Branch</Form.Label>

                            <Select className="" id="txtBranchName" 
                             options={DtBranch}
                             isDisabled={isDisabled}
                             value={DtBranch.filter(function(option) {
                              return option.value === BranchCode;
                            })}
                            onChange=
                            {
                              (e) => {
                            setBranchCode(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>


                           
                          </div>


                        </div>
                        
                        
                      </div>

                    </div>

                  </div>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='d-flex flex-row justify-content-around'>
                        <div >
                          <Form.Check.Input value="SMITH" id="optSmith" name="group_partytype" type="radio" className='me-2' />
                          <Form.Check.Label>SMITH</Form.Check.Label>
                        </div>
                        <div >
                          <Form.Check.Input value="DEALER"  id="optDealer"  name="group_partytype" type="radio" className='me-2'  />
                          <Form.Check.Label>DEALER</Form.Check.Label>
                        </div>
                        
                      </div>
                      <div className='container-fluid py-4 '>
                        <div className='row '>
                          <div className='row py-2'>
                            <div className='col-md-6'>
                              <Form.Label>Order No</Form.Label>
                             <select className="form-select" hidden={OrderVis} id="txtOrderNo"   Disabled={isDisabled} value={OrderNo}>
                              { 
                              DtOrderNo.map(
                              (item)=>(
                              <option value={item.OrderNo}>{item.OrderNo}</option>
                              )
                              )
                              }
                             </select>
                             <Form.Control type="text" hidden={!OrderVis}  value={OrderNo} id="txtOrderNo" Readonly="ReadOnly" className="txtReadOnly" placeholder="" />
                   

                            </div>
                            
                          </div>
                          <div className='col-md-12 py-2'>
                            <Form.Label>Remark</Form.Label>
                            <Form.Control type="text" id="txtRemarks" placeholder="" />
                          </div>

                        
                        </div>
                      </div>
                    </div>
                  </div>

                 
                 
                                              
                </div>
              </div>
			  
			  
			    
				
              <Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-xl" id ="OrnamentRecStoneModal"  >
                  <Modal.Header closeButton>
                    <Modal.Title>Stone Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-6'>
                              <Form.Label>Stone Product</Form.Label>

                              <Select className="" id="txtStProductName" 
                             options={DtStProduct}
                             value={DtStProduct.filter(function(option) {
                              return option.value === StProdName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setStProdName(e.value);
                            getStSubProduct();
                              }
                              }
                             disabled={false}>
              				       </Select>

                           
                            </div>
                    


                     <div className='col-md-6'>
                              <Form.Label>Stone Sub Product</Form.Label>


                              <Select className="" id="txtStSubProdName" 
                             options={DtStSubProduct}
                             value={DtStSubProduct.filter(function(option) {
                              return option.value === StSubProdName;
                            })}
                            onChange=
                            {
                              (e) => {
                                setStSubProdName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>


                            
                            </div>
                
                            <div className='col-md-2'>
                              <Form.Label>Rec Mode</Form.Label>
                             <select className="form-select" id="txtStRecMode" onChange={StCalc} >
                              { 
                              DtStRecMode.map(
                              (item)=>(
                              <option value={item.RecMode}>{item.RecMode}</option>
                              )
                              )
                              }
                             </select>
                           

                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" id="txtStPcs" onKeyUp={StCalc}    placeholder="" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Weight</Form.Label>
                            <Form.Control type="text" id="txtStWt" onKeyUp={StCalc}  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Rate</Form.Label>
                            <Form.Control type="text" id="txtStPcsRate" onKeyUp={StCalc}    placeholder="" />
                            </div>
                           
                            <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                            <Form.Control type="text" id="txtStAmount"  Readonly="Readonly" placeholder="" className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Hnd.Chrgs</Form.Label>
                            <Form.Control type="text" id="txtStHnd" onKeyUp={StCalc}   placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Tax</Form.Label>
                            <Form.Control type="text" id="txtStTax" onKeyUp={StCalc}  placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Total Amount</Form.Label>
                            <Form.Control type="text" id="txtStTotalAmt"  Readonly="Readonly" placeholder="" className="txtReadOnly"  />
                            </div>
                            <div className='col-md-4'>
                              <Form.Label>Shape</Form.Label>
                            <Form.Control type="text" id="txtStShape"  placeholder=""   />
                            </div>

                            <div style={{ "text-align": 'center' }}>
                    <Button type="button" className="detbutton" id="cmdStoneSave"  variant="btn btn-primary" onClick={StgridAdd}>Add to Table</Button>
					              </div>


                       <div className="table-responsive mt-4" >
			 
				
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Edit</th>
             <th>Product</th>
             <th>Sub Product</th>
             <th>Mode</th>   
             <th>Pcs</th>              
             <th>Rate</th>
             <th>Weight</th>
             <th>Amount</th>
             <th>Hnd.Chrgs</th>
             <th>Tax</th>
             <th>Total Amount</th>
             
            <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtStDetTable.map((item) => (
           <tr >
              <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>StgridEdit(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             <td>{item.ProdName}</td>
             <td>{item.SubProdName}</td>
             <td>{item.RecMode}</td>
             <td>{item.Pcs}</td>
             <td>{item.PcsRate}</td>
             <td>{item.StWt}</td>
             <td>{item.StAmount}</td> 
             <td>{item.StHnd}</td>  
             <td>{item.StTax}</td>    
             <td>{item.StTotalAmt}</td>  
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>StgridRemove(item.ID)}>
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
             )
             )
              }     
         </tbody>
       </Table>
<div className="EntryPan">
<Button type="button" className="detbutton text-center btn-primary btn-icon btn-sm mt-lg-0  mt-md-0 mt-3 " id="cmdDetAdd"  variant="btn btn-primary" onClick={StClear}>
              
<i className="btn-inner">
           <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
           </svg>
         </i>
 </Button>
</div>
     </div>

     <div style={{ "direction": 'rtl' }}>
  
                    <Button type="button" className="detbutton" id="cmdStoneSave"  variant="btn btn-primary" onClick={CloseStoneScreen}>OK</Button>
                    <Button type="button" className="detbutton" id="cmdStoneNew" variant="btn btn-primary" onClick={TMhandleClose1}>Cancel</Button>
  </div>

</div>
</div>

                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>
				
				
				
			  
			  <Modal show={show1} onHide={handleClose1} className=".modal-xl" id="OrnamentRecModal" >
                  <Modal.Header closeButton>
                    <Modal.Title>Product Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-6'>
                              <Form.Label>Product</Form.Label>

                            <Select className="" id="txtProductName" 
                             options={DtProduct}
                             value={DtProduct.filter(function(option) {
                              return option.value === ProdName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setProdName(e.value);
                            getSubProduct();

                              }
                              }
                             disabled={false}>
              				       </Select>



                            
                            </div>
                    


                     <div className='col-md-6'>
                              <Form.Label>Sub Product</Form.Label>

                              <Select className="" id="txtSubProdName" 
                             options={DtSubProduct}
                             value={DtSubProduct.filter(function(option) {
                              return option.value === SubProdName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setSubProdName(e.value);
                            GetTouchDetail();
                              }
                              }
                             disabled={false}>
              				       </Select>


                             
                            </div>
                
                            <div className='col-md-3'>
                              <Form.Label>Purity</Form.Label>
                             <select className="form-select" id="txtPurity" >
                              { 
                              DtPurity.map(
                              (item)=>(
                              <option value={item.Purity}>{item.Purity}</option>
                              )
                              )
                              }
                             </select>
                             <Form.Control type="hidden" id="txtPurity1"  Readonly="Readonly" placeholder="" className="txtReadOnly" />
                         

                            </div>
                       

                            <div className='col-md-3'>
                              <Form.Label>Rec Mode</Form.Label>
                             <select className="form-select" id="txtRecMode" onChange={Calc} >
                              { 
                              DtRecMode.map(
                              (item)=>(
                              <option value={item.RecMode}>{item.RecMode}</option>
                              )
                              )
                              }
                             </select>
                           

                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" id="txtPcs" onKeyUp={Calc}    placeholder="" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" id="txtGrossWt" onKeyUp={Calc}  placeholder=""  />
                            </div>
                            
                            <div className='col-md-2'>
                              <Form.Label>Touch</Form.Label>
                            <Form.Control type="text" id="txtTouch" onKeyUp={Calc}  placeholder=""  />
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Less Wt</Form.Label>
                            <Form.Control type="text" id="txtLessWt" onKeyUp={Calc}  placeholder="" />
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Pcs Rate</Form.Label>
                            <Form.Control type="text" id="txtPcsRate" onKeyUp={Calc}    placeholder="" />
                            </div>
                           
                           
                            <div className='col-md-2'>
                              <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="text" id="txtNetWt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Total Wt</Form.Label>
                            <Form.Control type="text" id="txtTotalWt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Waste %</Form.Label>
                            <Form.Control type="text" id="txtWasteP"  onKeyUp={Calc} placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Waste/Grm</Form.Label>
                            <Form.Control type="text" id="txtWastePgrm"  onKeyUp={Calc} placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Mc/Grm</Form.Label>
                            <Form.Control type="text" id="txtMCPgrm" onKeyUp={Calc}  placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Mc/Pcs</Form.Label>
                            <Form.Control type="text" id="txtMCPPcs" onKeyUp={Calc}  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Mc Value</Form.Label>
                            <Form.Control type="text" id="txtMCValue"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            
                            <div className='col-md-2'>
                              <Form.Label>Wasteage</Form.Label>
                            <Form.Control type="text" id="txtWasteage" onKeyUp={Calc}  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Pure Wt</Form.Label>
                            <Form.Control type="text" id="txtPureWt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label><span className='spanLink' onClick={OpenStoneScreen}>Stone Amt</span></Form.Label>
                            <Form.Control type="text" id="txtStoneAmt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            <Form.Control type="hidden" id="txtStonePcs"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                         
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Othr.Chrgs</Form.Label>
                            <Form.Control type="text" id="txtOtherCharges" onKeyUp={Calc} placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Hallmark</Form.Label>
                            <Form.Control type="text" id="txtHallMark" onKeyUp={Calc}  placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Tot.Amt</Form.Label>
                            <Form.Control type="text" id="txtTotalAmt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Order No</Form.Label>
                            <Form.Control type="text" id="txtOrderNo1"  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Pcs Amount</Form.Label>
                            <Form.Control type="text" id="txtPcsAmt"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={gridAdd}>OK</Button>
					<Button type="button" className="detbutton" id="cmdDetNew" variant="btn btn-primary" onClick={Clear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
			  

                  
              <div className="table-responsive mt-4" >
			 
				
                <Table striped id="basic-table" className="table-striped mb-0" role="grid">
                  <thead>
                    <tr>
                    <th>Edit</th>
                      <th>Product</th>
                      <th>Sub Product</th>
                      <th>Purity</th>   
                      <th>Pcs</th>              
                      <th>Gross Wt</th>
                      <th>Less Wt</th>
                      <th>Net Wt</th>
                      <th>Waste %</th>
                      <th>Waste/Grm</th>
                      <th>Wasteage</th>
                      <th>MC/Pcs</th>
                      <th>MC/Grm</th>
                      <th>MC Value</th>
                      <th>Total Wt</th>  
                      <th>Touch</th>  
                      <th>Pure Wt</th>  
                      <th>St.Amt</th>  
                      <th>O.Amt</th>  
                      <th>HM</th>  
                      <th>Tot.Amt</th>  
                      <th>Pcs Rate</th>  
                      <th>Pcs Amt</th>  
                      <th>Order No</th>  
                      
						<th>Delete</th>					  
                    </tr>
                  </thead>
                  <tbody>
                  {DtDetTable.map((item) => (
                    <tr>
                      <td>
					   <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>gridEdit(item.ID)} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
						</td>
                      <td>{item.ProdName}</td>
                      <td>{item.SubProdName}</td>
                      <td>{item.Purity}</td>
                      <td>{item.Pcs}</td>
                      <td>{item.GrossWt}</td>
                      <td>{item.LessWt}</td>
                      <td>{item.NetWt}</td> 
                      <td>{item.WasteP}</td>  
                      <td>{item.WastePgrm}</td>    
                      <td>{item.Wasteage}</td>  
                      <td>{item.MCPPcs}</td>  
                      <td>{item.MCPgrm}</td>  
                      <td>{item.MCValue}</td>  
                      <td>{item.TotalWt}</td>    
                      <td>{item.Touch}</td>  
                      <td>{item.PureWt}</td>    
                      <td>{item.StoneAmt}</td>    
                      <td>{item.OtherCharges}</td>    
                      <td>{item.HallMark}</td>    
                      <td>{item.TotalAmt}</td>    
                      <td>{item.PcsRate}</td>  
                      <td>{item.PcsAmount}</td>  
                      <td>{item.OrderNo1}</td>  
                       
		
		<td>
					 <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>gridRemove(item.ID)}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
					</td>
                    </tr>
                      )
                      )
                       }     
                  </tbody>
                </Table>
				<div className="EntryPan">
				 <Button type="button" className="detbutton text-center btn-primary btn-icon btn-sm mt-lg-0  mt-md-0 mt-3 " id="cmdDetAdd" hidden={DetAdd}  variant="btn btn-primary" onClick={handleShow1}>
			  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
				  </Button>
				</div>
              </div>
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary'  onClick={TagPrint} >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
